import React, {useEffect, useState} from "react";
import styled from "styled-components";
import InfoBox from "../atoms/InfoBox";
import {device} from "../../assets/styles/media.js";

const VisualInfo = styled.div`
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, -50%);
    z-index: 1;

    ${device.pc} {
        bottom: 38px;
    }

    ${device.tablet} {
        bottom: 0;
        transform: translate(-50%, -10%);
    }

    ${device.mobile} {
        bottom: 0;
        transform: translate(-50%, -10%);
    }
`;

const InfoList = styled.ul`
    display: flex;
    justify-content: center;
    gap: 30px;
    margin: 0 auto;

    ${device.pc} {
        margin: 0 60px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
    }

    ${device.tablet} {
        display: grid;
        gap: 15px;
        margin: 0 auto;
        grid-template-columns: 1fr;
        place-items: center;
        max-width: 500px;
    }

    ${device.mobile} {
        display: grid;
        gap: 10px;
        margin: 0 auto;
        grid-template-columns: 1fr;
        place-items: center;
        max-width: 260px;
    }
`;

const VideoInfoBox = ({dayOffData}) => {
    const [infoList, setInfoList] = useState([]);
    useEffect(() => {
        const defaultList = [
            {
                en_title: "operating time",
                title: "",
                description: "",
                link: "/guide",
                link_title: "운영시간 페이지로 이동"
            },
            {
                en_title: "ticket",
                title: "요금 및 우대사항",
                description: "입장료 및 우대사항을 확인하세요",
                link: "/guide/price",
                link_title: "요금 및 우대사항 페이지로 이동"
            },
            {
                en_title: "reservation",
                title: "예약 (단체관람/프로그램)",
                description: "사전예약으로 방문 계획을 세워보세요",
                link: "/guide/group",
                link_title: "예약안내 페이지로 이동"
            }
        ];
        if (dayOffData) {
            defaultList[0].title = dayOffData.title;
            defaultList[0].description = dayOffData.desc;
        }
        setInfoList(defaultList);
    }, [dayOffData]);
    return (
        infoList.length > 0 && (
            <VisualInfo>
                <InfoList>
                    {infoList.map((item, index) => (
                        <InfoBox key={index} item={item}/>
                    ))}
                </InfoList>
            </VisualInfo>
        )
    );
};

export default VideoInfoBox;
